import { koComponent } from '../../../../ko-utils';
import $api from '../../../../api';

let articlesLoaded = false;

class ArticlesPerformanceView {
    constructor(params) {
        this.isVisible = params.isVisible;
        this.isVisible.subscribe(val => {
            this.reinitIfVisible();
        });

        this.globalDateRange = params.globalDateRange;
        this.globalDateRange.subscribe(() => {
            this.reinitIfVisible();
        });

        this.generalChartState = ko.observable('loading');

        this.lock = waiter();

        this.stats = ko.observableArray();
        this.articles = [];

        this.reinitIfVisible();
    }

    get globalDateRangeUnwrapped() {
        return ko.unwrap(this.globalDateRange);
    }

    dispose() {
    }

    reinitIfVisible() {
        if (ko.unwrap(this.isVisible)) {
            this.reinit();
        }
    }

    reinit() {
        this.generalChartState('loading');

        if (!articlesLoaded) {
            $api.customerCenter.getAllArticles({ projectCode: auth.project.UniqueCode, includeContent: false }, { a: 1 }, (resp) => {
                this.articles = resp;

                this.lock.unlocker();
            });

            articlesLoaded = true;
        }

        this.loadGeneralChart();
    }

    loadGeneralChart() {
        this.lock.waiter.then(() => {
            $api.customerCenter.getSearchStats(
                {
                    projectCode: auth.project.UniqueCode,
                    dateFrom: this.globalDateRangeUnwrapped[0].toJSON(),
                    dateTo: this.globalDateRangeUnwrapped[1].toJSON()
                },
                {},
                (resp) => {
                    this.stats(resp.keywords);

                    this.generalChartState('loaded');
                }
            );
        });
    }

    getArticleName(id) {
        const article = this.articles.filter(i => i.id == id)[0];

        if (!article) return '(deleted)';

        const contents = article.articleContents;
        const defaultLanguage = window.auth.project.SupportedLanguages[0];

        let cnt = contents.filter(c => c.language == defaultLanguage)[0]
        if (!cnt) {
            cnt = contents[0];
        }

        if (!cnt) {
            return '(deleted';
        }

        return cnt.title;
    }
}

function waiter() {
    let unlocker;
    const promise = new Promise((res) => unlocker = res);

    return {
        waiter: promise,
        unlocker
    }
}

export default koComponent('articles-performance-view', ArticlesPerformanceView);